import HomePage from "../pages/HomePage";
import AboutPage from "../pages/AboutPage";
import OfferingPage from "../pages/OfferingPage";
import MinistriesPage from "../pages/MinistriesPage";
import SermonsPage from "../pages/SermonsPage";
import JoinPage from "../pages/JoinPage";
import TeamPage from "../pages/TeamPage";
import DeclarationPage from "../pages/DeclarationPage";
import FAQPage from "../pages/FAQPage";
import EventsPage from "../pages/EventsPage";
import ExpectationPage from "../pages/ExpectationPage";
import WomenMinistryPage from "../pages/WomenMinistryPage";
import StudentMinistryPage from "../pages/StudentMinistryPage";
import ChildrenMinistryPage from "../pages/ChildrenMinistryPage";
import CommunitySchoolPage from "../pages/CommunitySchoolPage";
import DiscipleshipPage from "../pages/DiscipleshipPage";
import GospelMinistryPage from "../pages/GospelMinistryPage";
import Joshua2022Page from "../pages/Joshua2022Page";
import Romans2022Page from "../pages/Romans2022Page";
import Mark2023Page from "../pages/Mark2023Page";
import Genesis2020Page from "../pages/Genesis2020Page";
import OtherSermonsPage from "../pages/OtherSermonsPage";

// Ids must match PAGE_IDS in server/contentApiRoutes.js
const PAGE_REGISTRY = {
  home: { label: "主页", path: "/", component: HomePage },
  about: { label: "关于我们", path: "/about", component: AboutPage },
  offering: { label: "奉献", path: "/offering", component: OfferingPage },
  ministries: { label: "教会事工", path: "/ministries", component: MinistriesPage },
  sermons: { label: "讲道信息", path: "/sermons", component: SermonsPage },
  join: { label: "加入", path: "/join", component: JoinPage },
  team: { label: "同工团队", path: "/team", component: TeamPage },
  declaration: { label: "信仰宣言", path: "/declaration", component: DeclarationPage },
  faq: { label: "信仰解答", path: "/faq", component: FAQPage },
  events: { label: "活动剪影", path: "/events", component: EventsPage },
  expectation: { label: "期待", path: "/expectation", component: ExpectationPage },
  "women-ministry": { label: "妇女事工", path: "/women-ministry", component: WomenMinistryPage },
  "student-ministry": { label: "大学生事工", path: "/student-ministry", component: StudentMinistryPage },
  "children-ministry": { label: "儿童/学生事工", path: "/children-ministry", component: ChildrenMinistryPage },
  "community-school": { label: "社区事工/中文学校", path: "/community-school", component: CommunitySchoolPage },
  discipleship: { label: "门徒建造/小组团契", path: "/discipleship", component: DiscipleshipPage },
  "gospel-ministry": { label: "福音事工", path: "/gospel-ministry", component: GospelMinistryPage },
  "joshua-2022": { label: "2022 约书亚记", path: "/joshua-2022", component: Joshua2022Page },
  "romans-2022": { label: "2022 罗马书", path: "/romans-2022", component: Romans2022Page },
  "mark-2023": { label: "2023 马可福音", path: "/mark-2023", component: Mark2023Page },
  "genesis-2020": { label: "2020 创世纪", path: "/genesis-2020", component: Genesis2020Page },
  "other-sermons": { label: "其他讲道", path: "/other-sermons", component: OtherSermonsPage },
};

const PATH_TO_PAGE_ID = Object.fromEntries(
  Object.entries(PAGE_REGISTRY).map(([id, entry]) => [entry.path, id])
);

// Maps a real site path (e.g. "/about") to its /edit/preview/:pageId
// equivalent, so in-page navigation can stay inside preview mode.
// Falls back to the original path if there's no registered page for it.
export function getPreviewPathFor(realPath) {
  const id = PATH_TO_PAGE_ID[realPath];
  return id ? `/edit/preview/${id}` : realPath;
}

export default PAGE_REGISTRY;
